<template>
  <BaseIcon
    :active="active"
    :dark-mode="darkMode"
    :width="width"
    :height="height"
    :svg-path="'M11.9985 0.500001C12.237 0.499741 12.4695 0.575304 12.6622 0.715777C12.855 0.85625 12.9982 1.05436 13.071 1.2815L18 16.685L19.929 10.658C20.0015 10.4308 20.1443 10.2326 20.3368 10.0918C20.5293 9.95109 20.7615 9.87516 21 9.875H22.875C23.1734 9.875 23.4595 9.99353 23.6705 10.2045C23.8815 10.4155 24 10.7016 24 11C24 11.2984 23.8815 11.5845 23.6705 11.7955C23.4595 12.0065 23.1734 12.125 22.875 12.125H21.8205L19.071 20.7185C18.9981 20.9452 18.8551 21.143 18.6627 21.2833C18.4702 21.4236 18.2382 21.4991 18 21.4991C17.7618 21.4991 17.5298 21.4236 17.3373 21.2833C17.1449 21.143 17.0019 20.9452 16.929 20.7185L12.0075 5.339L8.5725 16.214C8.50163 16.4381 8.36236 16.6344 8.17424 16.7753C7.98612 16.9161 7.7586 16.9946 7.52362 16.9995C7.28864 17.0045 7.05801 16.9357 6.86411 16.8029C6.6702 16.6701 6.52277 16.4799 6.4425 16.259L4.5465 11.045L4.4415 11.357C4.36692 11.5809 4.2238 11.7757 4.0324 11.9138C3.841 12.0519 3.61102 12.1263 3.375 12.1265H1.125C0.826631 12.1265 0.540483 12.008 0.329505 11.797C0.118526 11.586 0 11.2999 0 11.0015C0 10.7031 0.118526 10.417 0.329505 10.206C0.540483 9.99503 0.826631 9.8765 1.125 9.8765H2.565L3.432 7.271C3.5055 7.04908 3.64631 6.85556 3.83485 6.71735C4.0234 6.57914 4.25032 6.50311 4.48408 6.49981C4.71783 6.49651 4.94681 6.56611 5.13918 6.69894C5.33155 6.83178 5.47777 7.02124 5.5575 7.241L7.425 12.3785L10.9275 1.2875C10.9992 1.05949 11.1417 0.860237 11.3342 0.718641C11.5268 0.577046 11.7595 0.500464 11.9985 0.500001Z'" />
</template>
<script>
import BaseIcon from "./BaseIcon.vue"
export default {
  components: {
    BaseIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    }
  }
}
</script>
